var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCapeVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C20.8494 32.0107 25.1946 29.853 28.1288 26.4456H3.87119C6.80537 29.853 11.1506 32.0107 16 32.0107Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0107C32 7.17424 24.8365 0.0107422 16 0.0107422C7.1635 0.0107422 0 7.17424 0 16.0107C0 17.4549 0.1925 18.8538 0.551188 20.1847H31.4489C31.8075 18.8538 32 17.4549 32 16.0107Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.27148 22.2715C1.57992 22.9962 1.94048 23.6932 2.34817 24.3584H29.6514C30.059 23.6932 30.4195 22.9962 30.7281 22.2715H1.27148Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4369 17.0542L11.6959 17.8513H12.5341L11.856 18.344L12.115 19.1411L11.4369 18.6484L10.7588 19.1411L11.0178 18.344L10.3398 17.8513H11.1779L11.4369 17.0542Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4369 27.489L11.6959 28.2862H12.5341L11.856 28.7788L12.115 29.576L11.4369 29.0833L10.7588 29.576L11.0178 28.7788L10.3398 28.2862H11.1779L11.4369 27.489Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57962 23.96L6.83862 24.757H7.67681L6.99875 25.2496L7.25775 26.0469L6.57962 25.5542L5.9015 26.0469L6.16062 25.2496L5.4825 24.757H6.32062L6.57962 23.96Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43493 18.0977L8.69393 18.8948H9.53206L8.85406 19.3875L9.11306 20.1847L8.43493 19.692L7.75681 20.1847L8.01593 19.3875L7.33775 18.8948H8.17593L8.43493 18.0977Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4825 21.3805L6.3205 21.3806L6.57956 20.5833L6.83862 21.3805L7.67681 21.3804L6.99869 21.8731L7.25775 22.6703L6.57956 22.1776L5.9015 22.6701L6.1605 21.8731L5.4825 21.3805Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75715 28.3803L8.01615 27.5833L7.33797 27.0906H8.17615L8.43522 26.2935L8.69428 27.0906H9.5324L8.85428 27.5832L9.11328 28.3805L8.43515 27.8877L7.75715 28.3803Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2923 23.96L16.0334 24.757H15.1952L15.8732 25.2496L15.6142 26.0469L16.2923 25.5542L16.9704 26.0469L16.7114 25.2496L17.3895 24.757H16.5513L16.2923 23.96Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.437 18.0977L14.1781 18.8948H13.3399L14.0179 19.3875L13.7589 20.1847L14.437 19.692L15.1151 20.1847L14.8561 19.3875L15.5342 18.8948H14.696L14.437 18.0977Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3895 21.3805L16.5514 21.3806L16.2924 20.5833L16.0334 21.3805L15.1952 21.3804L15.8732 21.8731L15.6142 22.6703L16.2924 22.1776L16.9704 22.6701L16.7114 21.8731L17.3895 21.3805Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1151 28.38L14.8561 27.583L15.5343 27.0904H14.6961L14.437 26.2932L14.178 27.0903H13.3398L14.0179 27.583L13.7589 28.3802L14.4371 27.8875L15.1151 28.38Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCapeVerde);
export default __webpack_public_path__ + "static/media/flag_cape_verde.85eb9ca3596e55dc54cd3367a32013c2.svg";
export { ForwardRef as ReactComponent };